import React, { useEffect, useState } from 'react';
export function TopBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="w-full py-3 px-4 text-center text-sm font-medium" style={{
    backgroundColor: '#1A1614',
    color: '#ffffff'
  }} data-id="element-299">
      <p className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2" data-id="element-300">
        <span className="text-[14px]" data-id="element-301">
          🔥 PRECIO DE LANZAMIENTO — Oferta expira en:
        </span>
        <span className="flex items-center gap-1.5" data-id="element-302">
          <span className="font-bold tabular-nums text-[20px]" style={{
          color: '#e76f51'
        }} data-id="element-303">
            {String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}
          </span>
          <span className="text-[16px]" data-id="element-304">⚡ ¡Aprovecha ya!</span>
        </span>
      </p>
    </div>;
}